<template>
  <v-content>
    <v-row>
      <v-col>
      </v-col>
      <v-col>
        <PasswordResetForm
          :setNewPassword="setNewPassword"
          v-on:passwordChanged="passwordChanged($event)"
          :busy="busy"
          v-if="noError"
        />
        <div v-else>
          Something went wrong...
        </div>
      </v-col>
      <v-col>

      </v-col>
    </v-row>
  </v-content>
</template>

<script>
import PasswordResetForm from '../components/PasswordResetForm.vue';

export default {
  name: 'RequestPasswordReset',
  components: {
    PasswordResetForm,
  },

  data() {
    return {
      password: '',
      busy: false,
      noError: true,
    };
  },

  methods: {
    setNewPassword() {
      console.log(`...set new password, token=${this.token}`);

      const options = {
        method: 'POST',
        url: '/reset/user_password/v1',
        data: {
          token: this.token,
          newPassword: this.password,
        },
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {
          this.busy = false;
          if (res.status === 200) {
            this.$router.replace('/login');
          } else {
            this.noError = false;
          }
        })
        .catch((err) => {
          this.busy = false;
          this.noError = false;
          console.log('reset password was rejected...');
        });
    },
    passwordChanged(value) {
      this.password = value;
    },
  },

  props: {
    token: {
      type: String,
      required: true,
    },
  },
};
</script>
